import { ChangeEvent } from "react";
import FormikError from "./Errors/FormikError";

interface ITextArea {
  placeholder?: string;
  customValue?: string;
  customOnChangeHandler?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  name: string;
  rows?: number;
  labelText?: string;
  formik?: any;
  readOnly?: boolean;
  className?: string;
}

function CustomTextArea({
  placeholder,
  customValue,
  customOnChangeHandler,
  rows,
  labelText,
  formik,
  name,
  readOnly,
  className,
}: ITextArea) {
  return (
    <div>
      {labelText && (
        <label className="text-gray text-md mb-8 flex w-full   text-14 font-medium ">
          {labelText}
        </label>
      )}
      <textarea
        readOnly={readOnly}
        className={`
            w-full rounded-5 border-1 border-solid border-gray-E8E8E8 p-12 transition ease-in-out placeholder:text-14 placeholder:text-gray-B8B5B5
            ${readOnly ? "focus:border-gray-E8E8E8 focus:outline-none focus:!ring-0" : ""}
            ${
              !!formik &&
              formik.touched[name] &&
              formik.errors[name] &&
              "!border-error focus:border-error focus:!shadow-none focus:!ring-0"
            }
            ${className}
        `}
        name={name}
        rows={rows || 3}
        placeholder={placeholder}
        value={!!formik ? formik.values?.[name] : customValue}
        onChange={!!formik ? formik.handleChange : customOnChangeHandler}
      />
      <FormikError formik={formik} name={name} marginTopClass="mt-0" />
    </div>
  );
}
export default CustomTextArea;
